export default __webpack_public_path__ + "static/media/sdmobile-tablet1.4045021d.svg";